import { z } from 'zod';

export const CREATE_AUTHOR_SCHEMA = z.object({
  name: z
    .string()
    .min(3, 'Минимальная длина 3 символа')
    .max(100, 'Максимальная длина 100 символов'),
  desctiption: z
    .string()
    .max(1000, 'Максимальная длина 1000 символов')
    .optional(),
});
